function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0l10 10m0-10L0 10",
  fill: "none",
  fillRule: "evenodd",
  stroke: "#2571BA",
  strokeWidth: 2
});

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMCAxMSI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2U9IiMyNTcxQkEiIHN0cm9rZS13aWR0aD0iMiI+CiAgICA8cGF0aCBkPSJNMCAwbDEwIDEwTTEwIDBMMCAxMCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgCloseIcon as ReactComponent };